import "./EditLocationWarningModal.scss";
import { Modal } from "antd";
import { Button } from "../misc/Button";
import { LocationDto } from "../../../generated/dashboard-client";
import React from "react";
import { useRecoilState } from "recoil";
import { memberState } from "../../../state/atoms";
import { isDesignSubscription, isProSubscription } from "../../../service/BillingService";

export interface EditLocationWarningModalProps {
  visible: boolean;
  location: LocationDto;
  onCancel: () => void;
  onContinue: (location: LocationDto) => void;
}

export default function EditLocationWarningModal({
                                                   location,
                                                   visible,
                                                   onCancel,
                                                   onContinue
                                                 }: EditLocationWarningModalProps) {
  const [member] = useRecoilState(memberState);

  function onAddLocation() {
    onCancel();
    if (!isProSubscription(member)) {
      if (isDesignSubscription(member)) {
        window.MHM.ProModal.switchToProWithOverview({
          memberId: member.id,
          onSuccess: () => window.location.reload()
        });
      } else {
        window.MHM.ProModal.upgrade({
          memberId: member.id,
          onSuccess: () => window.location.reload()
        });
      }
    } else {
      window.MHM.ProModal.addLocation({ memberId: member.id, onSuccess: () => window.location.reload() });
    }
  }

  return (
    <Modal
      className={"edit-location-warning-modal clean one"}
      visible={visible}
      onCancel={onCancel}
    >
      <section>
        <header>
          <h2>Update Location</h2>
        </header>

        <p className={"message"}>
          Changes to Business Name or Address will reflect on all Link Pages and
          Mobile Menus for this location.
        </p>
        <p>
          {!member.diningRDIntegrationDesign && <Button className={"add-location"} type={"LinkPrimary"} onClick={onAddLocation}>
            Add a Location
          </Button>}
        </p>
      </section>
      <footer>
        <Button
          type={"Cancel"}
          inverted
          size={"Large"}
          onClick={() => onCancel()}
        >
          <span>Cancel</span>
        </Button>
        <Button
          type={"Primary"}
          size={"Large"}
          onClick={() => {
            onContinue(location);
          }}
        >
          <span>Continue</span>
        </Button>
      </footer>
    </Modal>
  );
}
